@if (!hidden) {
<ng-container>
    <div class="e-selector-row">
        <emma-geography-selector [geographies]="geographies()" [projectGeographies]="projectGeographies()">
        </emma-geography-selector>

        <emma-expiry-selector>
        </emma-expiry-selector>

        <button class="e-load-button" [disabled]="!isLoadButtonEnable" (click)="loadSizesGridData()">
            <span>LOAD</span>
            <span class="far fa-angle-double-right"></span>
        </button>
    </div>

    <emma-control-bar #controlBar [rowCount]="rowCount">
    </emma-control-bar>

    @if (showMainGrid()) {
    <claims-main-grid #claims (selectionChange)="onGridSelectionChanged($event)" (rowCountChange)="rowCount = $event"
        [userGeographies]="geographies()" [projectGeographies]="projectGeographies()">
    </claims-main-grid>
    }
</ng-container>
}